__turbopack_context__.v({
  "post-article": "PostBody-module-scss-module__jcMvNa__post-article",
  "post-container": "PostBody-module-scss-module__jcMvNa__post-container",
  "post-details-and-controls": "PostBody-module-scss-module__jcMvNa__post-details-and-controls",
  "post-tag": "PostBody-module-scss-module__jcMvNa__post-tag",
});
